var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaludation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 191,
    viewBox: "0 0 175 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.6877 20.0594C99.796 36.3923 119.787 33.9344 133.352 30.4458C136.605 29.5737 139.937 28.6222 142.872 26.9572C145.807 25.2922 148.266 22.5965 149.218 19.3458C150.249 15.6986 149.059 11.655 146.997 8.4836C145.093 5.55002 142.316 2.45786 139.381 0.554999C138.112 3.80573 133.59 4.04358 130.496 4.04358C126.133 4.04358 122.167 2.37858 118.121 1.18929C113.996 -3.39746e-06 109.553 -0.237861 105.428 0.872143C97.0988 2.85429 90.4352 11.3379 93.6877 20.0594Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.142 129.395C105.904 129.395 105.825 129.395 105.666 129.474L106.142 129.395Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.142 129.395C105.904 129.395 105.825 129.395 105.666 129.474L106.142 129.395Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5313 49.8709V34.5687C88.5313 21.5658 100.669 10.9415 115.503 10.9415C122.881 10.9415 129.624 13.5579 134.542 17.8393C139.461 22.1208 142.475 27.988 142.475 34.4894V49.7916",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.475 66.4417V84.1225C142.475 97.1254 130.338 107.75 115.503 107.75C100.669 107.75 88.5313 97.1254 88.5313 84.1225V66.4417",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4787 71.9124C107.058 71.9124 113.203 65.7714 113.203 58.1959C113.203 50.6205 107.058 44.4795 99.4787 44.4795C91.8992 44.4795 85.7548 50.6205 85.7548 58.1959C85.7548 65.7714 91.8992 71.9124 99.4787 71.9124Z",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.448 71.9124C139.028 71.9124 145.172 65.7714 145.172 58.1959C145.172 50.6205 139.028 44.4795 131.448 44.4795C123.869 44.4795 117.724 50.6205 117.724 58.1959C117.724 65.7714 123.869 71.9124 131.448 71.9124Z",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.123 57.7995H117.883",
    stroke: "#0C0B0B",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.53 105.609H126.609V130.425",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.777 130.108V106.243",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4787 61.3674C101.231 61.3674 102.652 59.9475 102.652 58.1959C102.652 56.4444 101.231 55.0245 99.4787 55.0245C97.7262 55.0245 96.3055 56.4444 96.3055 58.1959C96.3055 59.9475 97.7262 61.3674 99.4787 61.3674Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.448 61.3674C133.201 61.3674 134.621 59.9475 134.621 58.1959C134.621 56.4444 133.201 55.0245 131.448 55.0245C129.696 55.0245 128.275 56.4444 128.275 58.1959C128.275 59.9475 129.696 61.3674 131.448 61.3674Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7067 63.3495H85.1201C83.3749 63.3495 81.7883 64.0631 80.5984 65.1731C79.4878 66.3624 78.7738 67.9481 78.7738 69.6924C78.7738 73.181 81.6296 76.0353 85.1201 76.0353H88.2933",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.22 63.3495H145.807C149.297 63.3495 152.153 66.2038 152.153 69.6924C152.153 71.4367 151.439 73.0224 150.249 74.2117C149.139 75.3217 147.552 76.0353 145.807 76.0353H142.634",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3726 67.7896V71.5953H85.8341C84.8028 71.5953 83.9302 70.7231 83.9302 69.6924C83.9302 69.1374 84.1682 68.6617 84.4855 68.3446C84.8028 68.0274 85.2788 67.7896 85.8341 67.7896H88.3726Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.634 71.5953V67.7896H145.172C146.204 67.7896 147.076 68.6617 147.076 69.6924C147.076 70.2474 146.838 70.7231 146.521 71.0403C146.204 71.3574 145.728 71.5953 145.172 71.5953H142.634Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.503 71.2781C115.503 71.2781 111.537 77.621 117.883 76.0353",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.364 89.5932C108.364 89.5932 114.71 97.4425 123.436 89.5932",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.291 41.9423C93.291 41.9423 97.6541 37.5816 105.19 41.1495",
    stroke: "#0C0B0B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.715 41.9423C137.715 41.9423 133.352 37.5816 125.816 41.1495",
    stroke: "#0C0B0B",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3726 32.9037C88.3726 32.9037 77.4252 24.4201 82.1849 14.1129C86.9447 3.80572 102.017 9.35574 102.017 9.35574C102.017 9.35574 108.046 35.0444 88.3726 32.9037Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9529 96.2539C33.0009 93.1617 31.6523 91.6553 30.9383 87.136C29.4311 78.0974 29.9864 69.4552 26.2579 69.7723C24.7507 69.9309 24.2747 71.5166 24.354 72.3888L25.544 86.6603C25.068 88.3253 24.1954 87.691 24.1954 87.691C24.1954 87.691 21.1015 75.0052 20.7049 72.7059C20.3082 70.4859 19.1976 69.2173 17.6904 69.3759C15.0725 69.6138 16.1038 72.7852 16.3418 73.9745L19.1183 89.356C19.3563 90.8624 17.7697 90.3867 17.7697 90.3867L11.582 75.0052C10.8681 73.3402 9.51949 73.7366 9.51949 73.7366C7.06029 74.2916 8.01224 76.5116 8.01224 76.5116L13.3273 92.8446C13.3273 92.9239 13.3273 93.0031 13.3273 93.0824C13.4066 93.9546 12.296 94.4303 11.82 93.6374C10.1541 91.1003 6.90163 87.0567 4.20444 85.471C2.85585 84.6781 1.9039 84.8367 1.34859 85.2331C0.793288 85.6295 0.713959 86.3431 1.1106 86.8981L11.0267 101.249C13.3273 116.472 22.6088 118.295 22.6088 118.295L28.1618 140.02L36.3327 174.271L37.364 178.632C38.316 182.834 42.1237 185.847 46.4075 185.847H50.7706C53.8645 185.847 56.0063 182.834 55.0544 179.98L35.3014 119.881L34.4288 114.648C36.3327 112.508 37.602 107.988 38.2366 104.737C38.6333 102.993 38.7919 101.17 38.6333 99.4253C38.316 95.0646 41.2511 87.2153 41.2511 87.2153C41.0131 85.7088 38.1573 86.9774 38.1573 86.9774C34.9841 88.0874 34.1908 93.1617 33.9529 95.9367C33.8735 97.126 33.3182 98.1567 32.5249 98.9496C27.7652 103.627 27.3685 108.86 27.3685 108.86",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6256 72.7846C20.2289 70.5646 19.515 68.8996 17.6111 69.4546C15.0725 70.1681 16.0245 72.8638 16.2625 74.0531",
    stroke: "#0C0B0B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 190.207V191H157.706L154.057 170.782V191H79.1704V179.504C79.1704 176.729 79.1704 173.954 79.2498 171.179C77.5839 172.526 75.7593 173.636 73.6174 174.826L57.0376 185.926C56.9583 186.005 56.879 186.005 56.7996 186.084C56.0857 186.481 55.2924 186.719 54.4198 186.719L50.9719 186.849C50.9719 186.849 54.6578 185.45 55.5304 181.961L49.5807 162.14C58.0689 155.083 71.7928 134.707 98.1301 130.505C99.2407 130.267 100.431 130.029 101.7 129.87C102.89 129.712 104.08 129.553 105.428 129.474L106.301 129.395V129.553L105.825 129.633C105.984 129.633 106.063 129.633 106.222 129.553H106.301C106.46 129.553 106.618 129.553 106.777 129.474H106.856L107.65 129.395V132.408C107.65 132.804 107.808 133.28 108.205 133.676C109.395 135.024 112.092 136.055 115.345 136.293C115.9 136.372 116.455 136.372 117.01 136.372C117.09 136.372 117.169 136.372 117.169 136.372H117.248C120.422 136.293 123.357 135.421 124.864 134.152C125.34 133.756 125.816 133.201 125.816 132.408V129.633L126.609 129.791H126.768C127.006 129.791 127.165 129.87 127.403 129.87V129.633L128.434 129.791C157.548 133.359 175 155.956 175 190.207Z",
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9583 185.846L56.7203 186.005C56.7996 186.005 56.879 185.926 56.9583 185.846Z",
    fill: "#0C0B0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 191,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaludation);
export default __webpack_public_path__ + "static/media/saludation.ce3034e61ef4e193e181aebf6bee8168.svg";
export { ForwardRef as ReactComponent };